import { useQuery } from '@tanstack/react-query'
import { api } from '../api/client'
import { useUserContext } from '../providers/UserContextProvider'
import type { SetupConfig } from '../types'

/**
 * Hook to fetch and cache the organization's setup configuration.
 * Returns the full SetupConfig with defaults applied.
 */
export function useSetupConfig() {
  const { primaryContext, adminOrganizationId } = useUserContext()
  // An owner who holds only the admin track has no work context; without the
  // admin membership's organization, every level of their workspace read as
  // active and skipped levels were offered as if they existed.
  const organizationId = primaryContext?.organizationId ?? adminOrganizationId ?? undefined

  const { data, isLoading } = useQuery<SetupConfig>({
    queryKey: ['setup-config', organizationId],
    queryFn: () =>
      api.setupConfig.get(organizationId!).then((res) => res.data),
    enabled: !!organizationId,
    staleTime: 10 * 60 * 1000, // 10 minutes
  })

  return { config: data ?? null, isLoading }
}
